exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".onfile .handing-all-btn[data-v-095860f3]{margin-top:16px;margin-left:20px}.onfile-table[data-v-095860f3]{margin-top:16px}.pagination[data-v-095860f3]{margin-top:12px;text-align:right}[data-v-095860f3] .el-table__body td{padding:8px 0 !important;height:40px !important}\n", ""]);

// exports
